<template>
	<div class='knd-paragraaf knd-paragraaf-vimeo'>
		<div class='resp-container'>
			<iframe :src="data.content" width="640" height="360" frameborder="0"></iframe>
		</div>
		<div class='' v-html="data.description"></div>
	</div>
</template>

<script>

	const vueObject = {
		props: ['data'],
		mounted: function() {},
		methods: {}
	}

	export default vueObject;
</script>